// Sample Database for UI Testing
// This file contains mock data for all database schemas to test UI components

// Helper function to generate dates
const generateDate = (daysFromNow = 0) => {
  const date = new Date();
  date.setDate(date.getDate() + daysFromNow);
  return date.toISOString();
};

// Sample User Profiles
export const userProfiles = [
  {
    id: "a1b2c3d4-e5f6-7890-abcd-ef1234567890",
    first_name: "John",
    last_name: "Doe",
    created_at: generateDate(-30)
  },
  {
    id: "b2c3d4e5-f6g7-8901-bcde-f23456789012",
    first_name: "Sarah",
    last_name: "Johnson",
    created_at: generateDate(-25)
  },
  {
    id: "c3d4e5f6-g7h8-9012-cdef-345678901234",
    first_name: "Michael",
    last_name: "Chen",
    created_at: generateDate(-20)
  },
  {
    id: "d4e5f6g7-h8i9-0123-defg-456789012345",
    first_name: "Emily",
    last_name: "Rodriguez",
    created_at: generateDate(-15)
  },
  {
    id: "e5f6g7h8-i9j0-1234-efgh-567890123456",
    first_name: "David",
    last_name: "Williams",
    created_at: generateDate(-10)
  }
];

// Sample Roles
export const roles = [
  { id: 1, name: "admin" },
  { id: 2, name: "researcher" },
  { id: 3, name: "veterinarian" },
  { id: 4, name: "pet_parent" },
  { id: 5, name: "data_analyst" },
  { id: 6, name: "organization_manager" }
];

// Sample User Roles
export const userRoles = [
  { id: 1, user_id: "a1b2c3d4-e5f6-7890-abcd-ef1234567890", role_id: 1 },
  { id: 2, user_id: "b2c3d4e5-f6g7-8901-bcde-f23456789012", role_id: 2 },
  { id: 3, user_id: "c3d4e5f6-g7h8-9012-cdef-345678901234", role_id: 3 },
  { id: 4, user_id: "d4e5f6g7-h8i9-0123-defg-456789012345", role_id: 4 },
  { id: 5, user_id: "e5f6g7h8-i9j0-1234-efgh-567890123456", role_id: 5 },
  { id: 6, user_id: "a1b2c3d4-e5f6-7890-abcd-ef1234567890", role_id: 6 }
];

// Sample Organizations
export const organizations = [
  {
    id: "org-001-research-institute",
    name: "PetVet Research Institute",
    type: "research_facility",
    created_at: generateDate(-60)
  },
  {
    id: "org-002-animal-hospital",
    name: "Urban Animal Hospital",
    type: "veterinary_clinic",
    created_at: generateDate(-45)
  },
  {
    id: "org-003-analytics-corp",
    name: "Pet Health Analytics Corp",
    type: "technology_company",
    created_at: generateDate(-30)
  },
  {
    id: "org-004-wellness-foundation",
    name: "Animal Wellness Foundation",
    type: "non_profit",
    created_at: generateDate(-90)
  }
];

// Sample Organization Members
export const organizationMembers = [
  {
    id: 1,
    user_id: "a1b2c3d4-e5f6-7890-abcd-ef1234567890",
    organization_id: organizations[0].id,
    role_id: 1
  },
  {
    id: 2,
    user_id: "b2c3d4e5-f6g7-8901-bcde-f23456789012",
    organization_id: organizations[0].id,
    role_id: 2
  },
  {
    id: 3,
    user_id: "c3d4e5f6-g7h8-9012-cdef-345678901234",
    organization_id: organizations[1].id,
    role_id: 3
  },
  {
    id: 4,
    user_id: "d4e5f6g7-h8i9-0123-defg-456789012345",
    organization_id: organizations[2].id,
    role_id: 4
  }
];

// Sample Pets
export const pets = [
  {
    id: "pet-001-buddy-golden",
    name: "Buddy",
    universal_id: "PET-001-2024",
    teletails_id: "TT-DOG-12345",
    created_at: generateDate(-40)
  },
  {
    id: "pet-002-whiskers-tabby",
    name: "Whiskers",
    universal_id: "PET-002-2024",
    teletails_id: "TT-CAT-12346",
    created_at: generateDate(-35)
  },
  {
    id: "pet-003-max-labrador",
    name: "Max",
    universal_id: "PET-003-2024",
    teletails_id: "TT-DOG-12347",
    created_at: generateDate(-30)
  },
  {
    id: "pet-004-luna-siamese",
    name: "Luna",
    universal_id: "PET-004-2024",
    teletails_id: "TT-CAT-12348",
    created_at: generateDate(-25)
  },
  {
    id: "pet-005-charlie-beagle",
    name: "Charlie",
    universal_id: "PET-005-2024",
    teletails_id: "TT-DOG-12349",
    created_at: generateDate(-20)
  }
];

// Sample Pet Parents
export const petParents = [
  {
    id: "parent-001-alice-smith",
    first_name: "Alice",
    last_name: "Smith",
    email: "alice.smith@email.com",
    phone_number: "+1-555-0101",
    teletails_id: "TT-PARENT-001",
    created_at: generateDate(-45)
  },
  {
    id: "parent-002-robert-brown",
    first_name: "Robert",
    last_name: "Brown",
    email: "robert.brown@email.com",
    phone_number: "+1-555-0102",
    teletails_id: "TT-PARENT-002",
    created_at: generateDate(-40)
  },
  {
    id: "parent-003-maria-garcia",
    first_name: "Maria",
    last_name: "Garcia",
    email: "maria.garcia@email.com",
    phone_number: "+1-555-0103",
    teletails_id: "TT-PARENT-003",
    created_at: generateDate(-35)
  },
  {
    id: "parent-004-james-wilson",
    first_name: "James",
    last_name: "Wilson",
    email: "james.wilson@email.com",
    phone_number: "+1-555-0104",
    teletails_id: "TT-PARENT-004",
    created_at: generateDate(-30)
  }
];

// Sample Pet Parent Links
export const petParentLinks = [
  {
    id: "link-001-buddy-alice",
    pet_id: pets[0].id,
    pet_parent_id: petParents[0].id,
    created_at: generateDate(-40)
  },
  {
    id: "link-002-whiskers-robert",
    pet_id: pets[1].id,
    pet_parent_id: petParents[1].id,
    created_at: generateDate(-35)
  },
  {
    id: "link-003-max-maria",
    pet_id: pets[2].id,
    pet_parent_id: petParents[2].id,
    created_at: generateDate(-30)
  },
  {
    id: "link-004-luna-james",
    pet_id: pets[3].id,
    pet_parent_id: petParents[3].id,
    created_at: generateDate(-25)
  },
  {
    id: "link-005-charlie-alice",
    pet_id: pets[4].id,
    pet_parent_id: petParents[0].id, // Alice has two pets
    created_at: generateDate(-20)
  }
];

// Sample Incubations
export const incubations = [
  {
    id: "incubation-001-canine-obesity",
    name: "Canine Obesity Prevention Study",
    start_date: "2024-01-15",
    end_date: "2024-06-15",
    overview: "A comprehensive study examining dietary interventions for preventing obesity in dogs.",
    purpose: "To evaluate the effectiveness of different dietary approaches in maintaining healthy weight in canines.",
    eligibility_survey_url: "https://survey.example.com/canine-obesity",
    feedback_survey_url: "https://feedback.example.com/canine-obesity",
    inclusion_criteria: [
      { name: "Dogs aged 2-8 years" },
      { name: "No existing health conditions" },
      { name: "Owner commitment to 6-month study" }
    ],
    exclusion_criteria: [
      { name: "Dogs with diabetes" },
      { name: "Dogs on special medication" }
    ],
    status: "active",
    created_at: generateDate(-90)
  },
  {
    id: "incubation-002-feline-stress",
    name: "Feline Stress Monitoring",
    start_date: "2024-02-01",
    end_date: "2024-08-01",
    overview: "Monitoring stress levels in indoor cats using wearable technology.",
    purpose: "To develop better understanding of stress indicators in domestic cats.",
    eligibility_survey_url: null,
    feedback_survey_url: "https://feedback.example.com/feline-stress",
    inclusion_criteria: [
      { name: "Indoor cats only" },
      { name: "Cats aged 1-10 years" },
      { name: "No recent veterinary procedures" }
    ],
    exclusion_criteria: [
      { name: "Cats with chronic illness" },
      { name: "Outdoor cats" }
    ],
    status: "active",
    created_at: generateDate(-75)
  },
  {
    id: "incubation-003-senior-wellness",
    name: "Senior Pet Wellness Program",
    start_date: "2023-10-01",
    end_date: "2024-04-01",
    overview: "Comprehensive wellness monitoring for senior pets using IoT devices.",
    purpose: "To improve quality of life for aging pets through continuous health monitoring.",
    eligibility_survey_url: "https://survey.example.com/senior-pets",
    feedback_survey_url: "https://feedback.example.com/senior-pets",
    inclusion_criteria: [
      { name: "Pets aged 8+ years" },
      { name: "No terminal illnesses" },
      { name: "Regular veterinary care" }
    ],
    exclusion_criteria: [
      { name: "Pets with severe mobility issues" },
      { name: "Pets requiring constant care" }
    ],
    status: "completed",
    created_at: generateDate(-180)
  }
];

// Sample Default Data Fields
export const defaultDataFields = [
  {
    id: "field-001-weight",
    name: "weight",
    type: "number",
    created_at: generateDate(-200)
  },
  {
    id: "field-002-activity-level",
    name: "activity_level",
    type: "select",
    created_at: generateDate(-200)
  },
  {
    id: "field-003-diet-type",
    name: "diet_type",
    type: "text",
    created_at: generateDate(-200)
  },
  {
    id: "field-004-health-conditions",
    name: "health_conditions",
    type: "textarea",
    created_at: generateDate(-200)
  },
  {
    id: "field-005-vaccination-status",
    name: "vaccination_status",
    type: "boolean",
    created_at: generateDate(-200)
  }
];

// Sample Incubation Data Fields
export const incubationDataFields = [
  {
    id: "inc-field-001-obesity-study",
    incubation_id: incubations[0].id,
    fields: [
      { field_name: "initial_weight", field_type: "number" },
      { field_name: "target_weight", field_type: "number" },
      { field_name: "current_diet", field_type: "text" },
      { field_name: "exercise_routine", field_type: "textarea" }
    ],
    created_at: generateDate(-85)
  },
  {
    id: "inc-field-002-stress-study",
    incubation_id: incubations[1].id,
    fields: [
      { field_name: "stress_baseline", field_type: "number" },
      { field_name: "environment_type", field_type: "select" },
      { field_name: "behavioral_notes", field_type: "textarea" }
    ],
    created_at: generateDate(-70)
  }
];

// Sample Incubation Participants
export const incubationParticipants = [
  {
    id: "participant-001-buddy-obesity",
    pet_incubation_id: "CANINE-OB-001",
    pet_id: pets[0].id,
    incubation_id: incubations[0].id,
    incubation_fields: {
      initial_weight: 32.5,
      target_weight: 28.0,
      current_diet: "Hill's Weight Management",
      exercise_routine: "30 minutes daily walks, weekend hikes"
    },
    incubation_criteria_fields: {
      age_verified: true,
      health_cleared: true,
      owner_committed: true
    },
    incubation_exclusion_fields: {
      has_diabetes: false,
      on_special_medication: false
    },
    created_at: generateDate(-80)
  },
  {
    id: "participant-002-max-obesity",
    pet_incubation_id: "CANINE-OB-002",
    pet_id: pets[2].id,
    incubation_id: incubations[0].id,
    incubation_fields: {
      initial_weight: 45.2,
      target_weight: 40.0,
      current_diet: "Royal Canin Weight Care",
      exercise_routine: "Swimming twice weekly, daily walks"
    },
    incubation_criteria_fields: {
      age_verified: true,
      health_cleared: true,
      owner_committed: true
    },
    incubation_exclusion_fields: {
      has_diabetes: false,
      on_special_medication: false
    },
    created_at: generateDate(-75)
  },
  {
    id: "participant-003-whiskers-stress",
    pet_incubation_id: "FELINE-ST-001",
    pet_id: pets[1].id,
    incubation_id: incubations[1].id,
    incubation_fields: {
      stress_baseline: 3.2,
      environment_type: "apartment",
      behavioral_notes: "Generally calm, responds well to routine changes"
    },
    incubation_criteria_fields: {
      indoor_only: true,
      age_verified: true,
      no_recent_procedures: true
    },
    incubation_exclusion_fields: {
      has_chronic_illness: false,
      is_outdoor_cat: false
    },
    created_at: generateDate(-65)
  }
];

// Sample Functionalities
export const functionalities = [
  {
    id: "func-001-analytics-dashboard",
    name: "Data Analytics Dashboard",
    capabilities: "View charts, export data, generate reports",
    created_at: generateDate(-100)
  },
  {
    id: "func-002-incubation-management",
    name: "Incubation Management",
    capabilities: "Create, edit, manage incubation studies",
    created_at: generateDate(-100)
  },
  {
    id: "func-003-pet-health-monitoring",
    name: "Pet Health Monitoring",
    capabilities: "Track vital signs, health metrics, alerts",
    created_at: generateDate(-100)
  },
  {
    id: "func-004-user-administration",
    name: "User Administration",
    capabilities: "Manage users, roles, permissions",
    created_at: generateDate(-100)
  }
];

// Sample User Access
export const userAccess = [
  {
    id: "access-001-john-admin",
    user_id: "a1b2c3d4-e5f6-7890-abcd-ef1234567890",
    functionalities: [functionalities[0].id, functionalities[1].id, functionalities[3].id],
    incubations: [incubations[0].id, incubations[1].id],
    created_at: generateDate(-95)
  },
  {
    id: "access-002-sarah-researcher",
    user_id: "b2c3d4e5-f6g7-8901-bcde-f23456789012",
    functionalities: [functionalities[0].id, functionalities[2].id],
    incubations: [incubations[0].id],
    created_at: generateDate(-90)
  }
];

// Sample Activity Logs
export const activityLogs = [
  {
    id: "log-001-study-created",
    type: "incubation_created",
    description: "New incubation study created: Canine Obesity Prevention Study",
    incubation_id: incubations[0].id,
    organization_id: organizations[0].id,
    pet_parent_id: null,
    pet_id: null,
    data: {
      study_duration: "6 months",
      expected_participants: 50
    },
    date: generateDate(-90)
  },
  {
    id: "log-002-pet-enrolled",
    type: "pet_enrolled",
    description: "Pet enrolled in obesity prevention study",
    incubation_id: incubations[0].id,
    organization_id: organizations[0].id,
    pet_parent_id: petParents[0].id,
    pet_id: pets[0].id,
    data: {
      enrollment_date: generateDate(-80),
      initial_assessment: "completed"
    },
    date: generateDate(-80)
  },
  {
    id: "log-003-data-collected",
    type: "data_collected",
    description: "Weekly weight measurement recorded",
    incubation_id: incubations[0].id,
    organization_id: null,
    pet_parent_id: petParents[0].id,
    pet_id: pets[0].id,
    data: {
      measurement_type: "weight",
      value: 31.2,
      unit: "kg"
    },
    date: generateDate(-5)
  }
];

// Sample File Uploads
export const fileUploads = [
  {
    id: "file-001-study-protocol",
    incubation_id: incubations[0].id,
    user_id: "a1b2c3d4-e5f6-7890-abcd-ef1234567890",
    file_url: "https://storage.example.com/files/study-protocol-v1.pdf",
    file_name: "Canine_Obesity_Study_Protocol_v1.pdf",
    created_at: generateDate(-85)
  },
  {
    id: "file-002-monitoring-guide",
    incubation_id: incubations[1].id,
    user_id: "b2c3d4e5-f6g7-8901-bcde-f23456789012",
    file_url: "https://storage.example.com/files/stress-monitoring-guide.pdf",
    file_name: "Feline_Stress_Monitoring_Guide.pdf",
    created_at: generateDate(-70)
  },
  {
    id: "file-003-participant-data",
    incubation_id: incubations[0].id,
    user_id: "a1b2c3d4-e5f6-7890-abcd-ef1234567890",
    file_url: "https://storage.example.com/files/participant-data-week-12.xlsx",
    file_name: "Week_12_Participant_Data.xlsx",
    created_at: generateDate(-7)
  }
];

// Sample User Notifications
export const userNotifications = [
  {
    id: "notif-001-new-participant",
    user_id: "a1b2c3d4-e5f6-7890-abcd-ef1234567890",
    subject: "New Participant Enrolled",
    description: "A new participant has been enrolled in the Canine Obesity Prevention Study.",
    type: "enrollment",
    is_read: false,
    incubation_id: incubations[0].id,
    data: {
      participant_name: "Max",
      enrollment_date: generateDate(-1)
    },
    created_at: generateDate(-1)
  },
  {
    id: "notif-002-data-collection",
    user_id: "b2c3d4e5-f6g7-8901-bcde-f23456789012",
    subject: "Data Collection Reminder",
    description: "Weekly data collection is due for Feline Stress Monitoring study.",
    type: "reminder",
    is_read: true,
    incubation_id: incubations[1].id,
    data: {
      due_date: generateDate(2),
      collection_type: "behavioral_assessment"
    },
    created_at: generateDate(-3)
  },
  {
    id: "notif-003-study-milestone",
    user_id: "a1b2c3d4-e5f6-7890-abcd-ef1234567890",
    subject: "Study Milestone Achieved",
    description: "The Canine Obesity Prevention Study has reached 50% completion.",
    type: "milestone",
    is_read: false,
    incubation_id: incubations[0].id,
    data: {
      completion_percentage: 50,
      participants_active: 25
    },
    created_at: generateDate(-2)
  }
];

// Sample System Tickets
export const systemTickets = [
  {
    id: "ticket-001-dashboard-performance",
    organization_id: organizations[0].id,
    user_id: "a1b2c3d4-e5f6-7890-abcd-ef1234567890",
    status: "open",
    category: "technical_issue",
    subject: "Dashboard Loading Performance",
    description: "The analytics dashboard is taking longer than usual to load data visualizations. This is affecting our daily workflow.",
    created_at: generateDate(-5)
  },
  {
    id: "ticket-002-missing-records",
    organization_id: organizations[1].id,
    user_id: "c3d4e5f6-g7h8-9012-cdef-345678901234",
    status: "in_progress",
    category: "data_issue",
    subject: "Missing Pet Health Records",
    description: "Some pet health records from last week's data collection are not appearing in the system.",
    created_at: generateDate(-10)
  },
  {
    id: "ticket-003-access-request",
    organization_id: organizations[0].id,
    user_id: "b2c3d4e5-f6g7-8901-bcde-f23456789012",
    status: "resolved",
    category: "access_request",
    subject: "Access to New Incubation Study",
    description: "Requesting access to the newly created Senior Pet Wellness Program study.",
    created_at: generateDate(-15)
  }
];

// Sample System Ticket Comments
export const systemTicketComments = [
  {
    id: "comment-001-dashboard-issue",
    system_ticket_id: systemTickets[0].id,
    incubation_id: null,
    sender_user_id: "a1b2c3d4-e5f6-7890-abcd-ef1234567890",
    sender_name: "John Doe",
    comment_text: "I've noticed this issue is particularly problematic during peak hours (9-11 AM).",
    attachment_urls: ["https://storage.example.com/screenshots/dashboard-slow-loading.png"],
    created_at: generateDate(-4)
  },
  {
    id: "comment-002-performance-analysis",
    system_ticket_id: systemTickets[0].id,
    incubation_id: null,
    sender_user_id: "e5f6g7h8-i9j0-1234-efgh-567890123456",
    sender_name: "David Williams",
    comment_text: "We're investigating the database query performance. Initial findings suggest optimization opportunities in the data aggregation queries.",
    attachment_urls: [],
    created_at: generateDate(-3)
  },
  {
    id: "comment-003-missing-dates",
    system_ticket_id: systemTickets[1].id,
    incubation_id: incubations[1].id,
    sender_user_id: "c3d4e5f6-g7h8-9012-cdef-345678901234",
    sender_name: "Michael Chen",
    comment_text: "The missing records are specifically from March 15-17. All other dates appear to be complete.",
    attachment_urls: ["https://storage.example.com/reports/missing-records-list.csv"],
    created_at: generateDate(-9)
  }
];

// Sample System Feature Requests
export const systemFeatureRequests = [
  {
    id: "feature-001-realtime-viz",
    user_id: "a1b2c3d4-e5f6-7890-abcd-ef1234567890",
    incubation_id: incubations[0].id,
    organization_id: organizations[0].id,
    category: "analytics",
    subject: "Real-time Data Visualization",
    description: "It would be extremely helpful to have real-time charts that update automatically as new data comes in from the field devices.",
    created_at: generateDate(-12)
  },
  {
    id: "feature-002-mobile-app",
    user_id: "b2c3d4e5-f6g7-8901-bcde-f23456789012",
    incubation_id: incubations[1].id,
    organization_id: organizations[0].id,
    category: "mobile_app",
    subject: "Mobile Data Collection App",
    description: "A mobile application for field researchers to collect data directly from their smartphones would significantly improve data collection efficiency.",
    created_at: generateDate(-20)
  },
  {
    id: "feature-003-emr-integration",
    user_id: "c3d4e5f6-g7h8-9012-cdef-345678901234",
    incubation_id: null,
    organization_id: organizations[1].id,
    category: "integration",
    subject: "Veterinary EMR Integration",
    description: "Integration with common veterinary Electronic Medical Record systems would streamline the data import process.",
    created_at: generateDate(-25)
  }
];

// Sample System Feature Request Comments
export const systemFeatureRequestComments = [
  {
    id: "feat-comment-001-realtime-timeline",
    system_feature_id: systemFeatureRequests[0].id,
    incubation_id: incubations[0].id,
    sender_user_id: "e5f6g7h8-i9j0-1234-efgh-567890123456",
    sender_name: "David Williams",
    comment_text: "This is a great suggestion. We're evaluating WebSocket technology for real-time updates. Expected timeline is Q2 2024.",
    attachment_urls: ["https://storage.example.com/specs/realtime-viz-mockup.pdf"],
    created_at: generateDate(-10)
  },
  {
    id: "feat-comment-002-mobile-support",
    system_feature_id: systemFeatureRequests[1].id,
    incubation_id: incubations[1].id,
    sender_user_id: "a1b2c3d4-e5f6-7890-abcd-ef1234567890",
    sender_name: "John Doe",
    comment_text: "I support this request. A mobile app would also help with data quality by enabling immediate validation at the point of collection.",
    attachment_urls: [],
    created_at: generateDate(-18)
  },
  {
    id: "feat-comment-003-tech-research",
    system_feature_id: systemFeatureRequests[1].id,
    incubation_id: null,
    sender_user_id: "b2c3d4e5-f6g7-8901-bcde-f23456789012",
    sender_name: "Sarah Johnson",
    comment_text: "We've started preliminary research on React Native vs Flutter for cross-platform development. Will share findings soon.",
    attachment_urls: ["https://storage.example.com/research/mobile-tech-comparison.pdf"],
    created_at: generateDate(-15)
  }
];

// Export all sample data as a single object for easy import
export const SampleDatabase = {
  userProfiles,
  roles,
  userRoles,
  organizations,
  organizationMembers,
  incubations,
  incubationDataFields,
  defaultDataFields,
  incubationParticipants,
  pets,
  petParents,
  petParentLinks,
  functionalities,
  userAccess,
  activityLogs,
  fileUploads,
  userNotifications,
  systemTickets,
  systemTicketComments,
  systemFeatureRequests,
  systemFeatureRequestComments
};

// Helper functions for common data operations
export const getters = {
  // Get user by ID
  getUserById: (id) => userProfiles.find(user => user.id === id),
  
  // Get user's roles
  getUserRoles: (userId) => {
    const userRoleIds = userRoles.filter(ur => ur.user_id === userId).map(ur => ur.role_id);
    return roles.filter(role => userRoleIds.includes(role.id));
  },
  
  // Get organization members
  getOrganizationMembers: (orgId) => {
    return organizationMembers.filter(member => member.organization_id === orgId);
  },
  
  // Get pets for a pet parent
  getPetsByParent: (parentId) => {
    const petIds = petParentLinks.filter(link => link.pet_parent_id === parentId).map(link => link.pet_id);
    return pets.filter(pet => petIds.includes(pet.id));
  },
  
  // Get active incubations
  getActiveIncubations: () => incubations.filter(inc => inc.status === 'active'),
  
  // Get incubation participants
  getIncubationParticipants: (incubationId) => {
    return incubationParticipants.filter(participant => participant.incubation_id === incubationId);
  },
  
  // Get unread notifications for user
  getUnreadNotifications: (userId) => {
    return userNotifications.filter(notif => notif.user_id === userId && !notif.is_read);
  },
  
  // Get open tickets for organization
  getOpenTickets: (orgId) => {
    return systemTickets.filter(ticket => ticket.organization_id === orgId && ticket.status !== 'resolved');
  },
  
  // Get recent activity logs
  getRecentActivityLogs: (limit = 10) => {
    return activityLogs.sort((a, b) => new Date(b.date) - new Date(a.date)).slice(0, limit);
  }
};

export default SampleDatabase;
